import React, { useEffect, useMemo, useState } from 'react';

/**
 * Product thumbnail using authenticated image URL.
 * Uses ?token= so <img> works without blob fetch races during search/filter remounts.
 */
const ProductImage = ({
  productId,
  hasImage = false,
  alt = 'Product',
  className = '',
  size = 40,
  placeholder = null,
  cacheKey = ''
}) => {
  const [failed, setFailed] = useState(false);

  const src = useMemo(() => {
    if (!hasImage || !productId) return null;
    const token = localStorage.getItem('token');
    if (!token) return null;
    const params = new URLSearchParams({ token });
    if (cacheKey) params.set('v', String(cacheKey));
    return `/api/products/${productId}/image?${params.toString()}`;
  }, [productId, hasImage, cacheKey]);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    if (placeholder) return placeholder;
    return (
      <div
        className={`product-image-placeholder ${className}`.trim()}
        style={{ width: size, height: size }}
        aria-hidden="true"
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={`product-image-thumb ${className}`.trim()}
      style={{ width: size, height: size, objectFit: 'cover' }}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
};

/** Kept for call sites that clear cache after upload; no-op with URL-based images. */
export function clearProductImageCache() {}

export default ProductImage;
